import { Button } from '@/components/button';
import { CommonButtonProps } from '../../button';
import { SelectProviderButtonContainer } from './select-provider-button-container';
import { GetProviderResponseItem } from '@/api/api.schemas';

interface SelectProviderButtonProps extends CommonButtonProps {
  provider?: GetProviderResponseItem;
}

export function SelectProviderButton({ provider, ...buttonProps }: SelectProviderButtonProps) {
  return (
    <SelectProviderButtonContainer provider={provider}>
      {(handleSelect, loading) => (
        <Button size="M" onClick={handleSelect} loading={loading} {...buttonProps} />
      )}
    </SelectProviderButtonContainer>
  );
}
